import React from 'react';
import { connect } from 'react-redux';

import { CircularProgress } from 'material-ui/Progress';

import Console from '../../lib/debug';

const AppStatus = props => {
    Console.render('AppStatus');

    if (!props.loggedInUser) return null;

    let loading = null;
    if (props.appLoading) {
        loading = <CircularProgress style={{ color: '#fff' }} size={13} />;
    }

    return (
        <span className="app-status">
            {loading} {props.appMessage}
        </span>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        loggedInUser: state.app.loggedInUser,
        appLoading: state.app.appLoading,
        appMessage: state.app.appMessage
    };
};

export default connect(mapStateToProps)(AppStatus);



// WEBPACK FOOTER //
// ./src/view/common/AppStatus.jsx